import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import moment from "moment";
import "./styles.css";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
/*import TimePicker from 'react-time-picker';*/
import "antd/dist/antd.css";
import { TimePicker } from "antd";
import Util from "../../../Common/util";
import API from "../../../Common/api";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';

/*import './styles.css';
 */
var url = window.location.hostname;
var port = window.location.port;
var data = [];

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.Errortoggle = this.Errortoggle.bind(this);
    this.BinErrortoggle = this.BinErrortoggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchGRNData = this.fetchGRNData.bind(this);
    this.btnClick = this.btnClick.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.showTypeahead = this.showTypeahead.bind(this);
    this.showTypeaheadChange = this.showTypeaheadChange.bind(this);
    this.closeContainerIndex = this.closeContainerIndex.bind(this);
    this.closeContainer = this.closeContainer.bind(this);
    this.setBinId = this.setBinId.bind(this);
    this.onQuantityChange1 = this.onQuantityChange1.bind(this);
    this.processData = this.processData.bind(this);
    this.CancelErrorToggle = this.CancelErrorToggle.bind(this);
    this.ConfirmPutAway = this.ConfirmPutAway.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.CancelSuccessToggle = this.CancelSuccessToggle.bind(this);
    this.Confirmtoggle = this.Confirmtoggle.bind(this);
    this.CancelConfirmToggle = this.CancelConfirmToggle.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleChangeTime = this.handleChangeTime.bind(this);

    this.accessCookie = this.accessCookie.bind(this);
    this.beforeConfirm = this.beforeConfirm.bind(this);
    this.CancelBeforeModal = this.CancelBeforeModal.bind(this);
    /*this.showTypeahead = this.showTypeahead.bind(this);*/
    this.state = {
      apiCall: false,
      showPassword: false,
      showConfirmLoader: false,
      ShowEditLoader: false,
      schemas: [],
      showFetchGRNData: false,
      rows: [],
      grnNumber: "",
      grnValues: "",
      selectedOptions: "",
      ErrorMessageVal: "",
      changeStatus: "",
      alertMessage: "",
      messageModal: false,
      BinErrormodal: false,
      postsGRN: [],
      postsProduct: [],
      tableRowsGRN: [],
      ErrorRowData: [],
      options: [],
      newArrayData: [],
      selectedUser: {},
      modal: false,
      Confirmmodal: false,
      disabledBtnConfirm: false,
      loadingbtn: false,
      typeaheadText: "",
      pkd_val: "",
      lbskuid_val: "",
      mrp_val: "",
      quantity: "",
      defaultquantity: "",
      putawayHistoryId: "",
      showTypeahead: false,
      zwz_search_pannel: false,
      data: [],
      binId: "",
      hover_nod_data: [],
      showContainer: [],
      setBinIdLoop: {},
      splitData: [],
      Errormodal: false,
      Successmodal: false,
      ErrorMessage: "",
      SuccessMessage: "",
      loadingGRNValue: false,
      disabledProperties: false,
      disable_submit_button: false,
    };
  }

  closeContainerIndex(index) {
    const { rows, showContainer } = this.state;
    this.setState({
      showContainer: showContainer.map((item, i) => false),
    });
  }

  setBinId(item) {
    this.setState({
      typeaheadText: item,
    });
  }

  CancelBeforeModal() {
    this.setState({
      modalbeforeConfirm: false,
    });
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8099";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
    });

    localStorage.setItem("userName", username);
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  CancelConfirmToggle() {
    this.setState({
      Confirmmodal: false,
    });
    window.location.reload();
  }

  beforeConfirm() {
    this.setState({
      selectedUser: {},
      modalbeforeConfirm: true,
      newArrayData: [],
    });

    /*var newArray = this.state.postsGRN.filter(status='UNHOLD');*/
    var arrayCartData = this.state.postsGRN;
    console.log(arrayCartData);
    this.setState({
      newArrayData: arrayCartData,
    });
    console.log(this.state.newArrayData);
  }

  onQuantityChange1(index, value) {
    this.closeContainer();
    const { rows } = this.state;
    this.setState({
      rows: rows.map((item, i) =>
        i === index ? { ...item, qty: value } : item
      ),
    });
  }

  handleChangeDate(key, date) {
    const { newArrayData } = this.state;
    this.setState(
      {
        newArrayData: newArrayData.map((item) => ({
          ...item,
          date:
            item.userName === key
              ? moment(new Date(date).getTime()).format("MM-DD-YYYY")
              : item.date || null,
        })),
      },
      () => {
        console.log(this.state.newArrayData);
      }
    );
  }

  handleChangeTime(key, time) {
    const timeval = moment(new Date(time).getTime()).format("HH:mm");
    console.log(timeval);
    const { newArrayData } = this.state;
    this.setState(
      {
        newArrayData: newArrayData.map((item) => ({
          ...item,
          time:
            item.userName === key
              ? moment(new Date(time).getTime()).format("HH:mm")
              : item.time || null,
        })),
      },
      () => {
        console.log(this.state.newArrayData);
      }
    );
  }

  ConfirmPutAway() {
    console.log(this.state.postsGRN);
    this.setState(
      {
        loadingbtn: true,
        disabledProperties: true,
        showConfirmLoader: true,
        /*disabledBtnConfirm: true,*/
        newArrayData: this.state.newArrayData.map((item) => ({
          ...item,
          error: item.time ? null : "Please select time.",
        })),
      },
      () => {
        /*this.state.newArrayData.forEach(item => {
        if(item.error){
          return
        }
      })*/
/*
        for (var i = 0; i < this.state.newArrayData.length; i++) {
          if (this.state.newArrayData[i].error) {
            return false;
          }
        }*/

        var arr = [];
        for (var i = 0; i < this.state.newArrayData.length; i++) {
          var orderData = {};
          orderData["putawayHistoryId"] =
            this.state.newArrayData[i].putawayHistoryId;
          orderData["location"] = this.state.selectedLocation;
          /*orderData["date"] =
            this.state.newArrayData[i].date +
            " " +
            this.state.newArrayData[i].time;*/
          /*orderData['time'] = this.state.newArrayData[i].time;*/

          /*orderData['remarks'] = 'dfghjk';*/

          console.log(orderData);

          arr.push(orderData);
        }

        this.setState({
          disabledBtnConfirm: true,
        });

        const payload = {
          arr_data: arr,
        };
         addAnalytics('Confirm Putaway', 'Confirm Putaway Clicked', this.state.data);

        API.post("/picking/confirmPutaway/v1/", { param: payload })

          .then((response) => {
            console.log(response.data.success);
            /*this.setState({
              Successmodal: true,
            })*/

            this.setState({
              loadingbtn: false,
              modalbeforeConfirm: false,
              showConfirmLoader: false,
            });

            this.Confirmtoggle();

            /*window.location.reload();*/
            /* if (response.data[0].success= true) {
             this.setState({
               Successmodal: true,
             })
 
             window.location.reload();
           }*/
          })
          .catch(function (error) {});
      }
    );
  }

  CancelErrorToggle() {
    this.setState({
      Errormodal: false,
    });

    this.handleRemoveRow();
  }

  CancelSuccessToggle() {
    this.setState({
      Successmodal: false,
    });
  }

  CancelSuccessToggle() {
    this.setState({
      Successmodal: false,
    });
  }

  onBinChange1(index, value) {
    /*showTypeahead = (e) => {*/

    /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/

    /*console.log(e.target.value);*/

    let { showContainer, rows } = this.state;
    showContainer[index] = true;
    this.setState(
      {
        showContainer,
        rows: rows.map((item, i) =>
          i === index ? { ...item, binId: value } : item
        ),
        /*data: data_val*/
      },
      () => {
        const payload = {
          location: this.state.selectedLocation,
          binAddress: value,
          putawayHistoryId: this.state.putawayHistoryId,
        };

        API.post("/picking/getBins/v1/", { param: payload })

          .then((response) => {
            data = response.data;
            console.log(response);
            this.setState({
              data: response.data,
            });
          })
          .catch(function (error) {});
      }
    );

    /*console.log(value);*/
  }

  setBinIdLoop(index, value) {
    const { rows, showContainer } = this.state;
    this.setState({
      rows: rows.map((item, i) =>
        i === index ? { ...item, binId: value } : item
      ),
      showContainer: showContainer.map((item, i) => false),
    });
  }

  hideTypeahead = (e) => {
    if (this.state.showTypeahead) {
      if (!this.typeahead.contains(e.target)) {
        this.setState({ showTypeahead: false });
      }
    }
  };

  handleAddRow = () => {
    this.setState((prevState, props) => {
      const row = {};
      return { rows: [...prevState.rows, row] };
    });
  };

  handleRemoveRow = () => {
    this.setState((prevState, props) => {
      return { rows: prevState.rows.slice(1) };
    });
  };

  handleRemoveRow1 = () => {
    this.setState((prevState, props) => {
      return {
        rows: prevState.rows.slice(6),
      };
    });
  };

  handleRemoveRow2 = () => {
    this.setState((prevState, props) => {
      return {
        rows: prevState.rows.slice(0),
      };
    });
  };

  showTypeaheadChange = (e) => {
    this.closeContainer();
    const value = e.target.value;
    this.setState({
      quantity: value,
    });
  };

  showTypeahead = (e) => {
    const value = e.target.value;
    this.setState(
      {
        typeaheadText: value,
      },
      () => {
        /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/
        this.setState({
          showTypeahead: true,
          zwz_search_pannel: true,
          /* data: data_val*/
        });

        const payload = {
          location: this.state.selectedLocation,
          binAddress: value,
          putawayHistoryId: this.state.putawayHistoryId,
        };

        API.post("/picking/getBins/v1/", { param: payload })

          .then((response) => {
            console.log(response);
            this.setState({
              data: response.data,
            });
          })
          .catch(function (error) {});
      }
    );
  };

  closeContainer() {
    this.setState({
      showTypeahead: false,
    });
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  Confirmtoggle() {
    this.setState((prevState) => ({ Confirmmodal: !prevState.Confirmmodal }));
  }

  Errortoggle() {
    this.setState((prevState) => ({ Errormodal: !prevState.Errormodal }));
  }

  BinErrortoggle() {
    this.setState((prevState) => ({ BinErrormodal: !prevState.BinErrormodal }));
  }

  Successtoggle() {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  togglePressCancel() {
    this.setState({
      modal: false,
    });
  }

  handleChange(event) {
    this.setState({
      value: event.target.data,
      grnValues: event.target.value,
    });

    console.log(this.state.grnValues);
    console.log(event.target.value);

    localStorage.setItem("grnValues", event.target.value);

    //this.fetchGRNData();
  }

  SubmitClick = () => {
    this.fetchGRNData();
  };

  componentDidMount() {
    const payload = {
      location: this.state.selectedLocation,
      grnType: 2,
    };

    API.post("/picking/fetchgrnList/v1/", { param: payload })

      .then((response) => {
        console.log(response);
        this.setState({
          schemas: response.data,
        });
      })
      .catch(function (error) {});

    /*this.fetchGRNData();*/
  }

  fetchGRNData() {
    var grnVal = localStorage.getItem("grnValues");
    this.setState({
      showFetchGRNData: true,
      loadingGRNValue: true,
    });

    const payload = {
      grnLineNumber: grnVal,
      grnType: 2,
      location: this.state.selectedLocation,
    };
    addAnalytics('Confirm Putaway', 'Confirm GRN Search Filter', this.state.data);

    API.post("/picking/fetchgrnInfo/v1/", { param: payload })

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ postsGRN: data });
      })

      .then(async () => {
        this.setState({
          tableRowsGRN: this.assemblePostsGRN(),
          isLoading: false,
          loadingGRNValue: false,
        });

        console.log(this.state.tableRowsGRN);
      });
  }

  assemblePostsGRN = () => {
    let postsGRN = this.state.postsGRN.map((post, index) => {
      return {
        /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

        /*putawayHistoryId: post.putawayHistoryId,*/
        /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/

        binId: post.binId,
        zone_name: post.zoneName,

        lbskuid: post.sku7Code,

        


        batch: post.batch,

        mrp: post.mrp,
        testerQuantity: post.outerQty,


        receivedIcldQuantity: post.receivedIcldQuantity,

       
        looseQuantity: post.looseQuantity,

        /*looseQuantity: post.looseQuantity,*/

        stnDate: post.stnDate,

        stnNumber: post.stnNumber,

        pkd: post.pkd,

        upc: post.upc,

        /*grnDateTime: post.grnDateTime,*/

        /*basePackDesc: post.basePackDesc,*/

        

        crateId: post.crateId,

      };
    });

    return postsGRN;
  };

  btnClick(
    binId,
    icldQuantity,
    TesterQuantity,
    LooseQuantity,
    PID,
    UPC,
    LBSKUID,
    MRP,
    PKD,
    totalQuantity
  ) {
    if (icldQuantity > 0) {
      this.setState({
        defaultquantity: icldQuantity,
        quantity: icldQuantity,
      });
    } else if (TesterQuantity > 0) {
      this.setState({
        defaultquantity: TesterQuantity,
        quantity: TesterQuantity,
      });
    } else if (LooseQuantity > 0) {
      this.setState({
        defaultquantity: LooseQuantity,
        quantity: LooseQuantity,
      });
    }

    this.setState({
      modal: true,
      typeaheadText: binId,
      /* quantity: icldQuantity,*/
      /*defaultquantity: icldQuantity,*/
      putawayHistoryId: PID,
      binId: binId,
      pkd_val: PKD,
      lbskuid_val: LBSKUID,
      mrp_val: MRP,
      rows: [],
      splitData: [],
      apiCall: false,
      ShowEditLoader: false,
    });
    this.handleRemoveRow1();
  }

  async processData() {
    var orderData = {};

    this.setState({
      ShowEditLoader: true,
      splitData: [],
      apiCall: false,
    });

    if (this.state.typeaheadText === "") {
      this.setState({
        ErrorMessageVal: "Please Enter Bin Address",
        apiCall: false,
        ShowEditLoader: false,
      });
      this.BinErrortoggle();
      return false;
    }

    if (this.state.quantity === "") {
      this.setState({
        ErrorMessageVal: "Please Enter Quantity",
        apiCall: false,
        ShowEditLoader: false,
      });
      this.BinErrortoggle();
      return false;
    }

    if (this.state.data.length === 0 && this.state.showTypeahead === true) {
      this.setState({
        ErrorMessageVal: "Please Enter Valid Bin Address",
        apiCall: false,
        ShowEditLoader: false,
      });
      this.BinErrortoggle();
      return false;
    } else {
      if (
        parseInt(this.state.defaultquantity) !== parseInt(this.state.quantity)
      ) {
        await this.setState({
          apiCall: true,
        });
      } else {
        await this.setState({
          apiCall: false,
        });
        if (this.state.typeaheadText !== this.state.binId) {
          await this.setState({
            apiCall: true,
          });
        } else {
          await this.setState({
            apiCall: false,
          });
        }
      }
      var total_Quantity = this.state.quantity;

      /*if (this.state.rows.length === 0) {
        console.log("enter this rows");
        this.setState({
            ErrorMessageVal: "Please Enter Bin Address"
          })
          this.BinErrortoggle();
           return false;
  
      }*/

      orderData["binAddress"] = this.state.typeaheadText;
      orderData["newPutawayQty"] = this.state.quantity;
      this.state.splitData.push(orderData);

      for (var i = 0; i < this.state.rows.length; i++) {
        if (this.state.rows.length === 0) {
          this.setState({
            ErrorMessageVal: "Please Enter Bin Address",
            apiCall: false,
            ShowEditLoader: false,
          });
          this.BinErrortoggle();
          return false;
        }
        /*if(this.state.data.indexOf(this.state.rows[i].binId) == -1){
           this.BinErrortoggle();
          return false;
        }*/
        if (this.state.rows[i].binId === "") {
          this.setState({
            ErrorMessageVal: "Please Enter Bin Address",
            apiCall: false,
            ShowEditLoader: false,
          });
          this.BinErrortoggle();
          return false;
        }

        if (this.state.rows[i].qty === "") {
          this.setState({
            ErrorMessageVal: "Please Enter Quantity",
            apiCall: false,
            ShowEditLoader: false,
          });
          this.BinErrortoggle();
          return false;
        }

        if (this.state.rows[i].binId === "") {
          alert("Please Select Bin Address");
          this.setState({ ShowEditLoader: false, apiCall: false });
          return false;
        }

        var neworderData = {};
        neworderData["binAddress"] = this.state.rows[i].binId;
        neworderData["newPutawayQty"] = this.state.rows[i].qty;

        if (neworderData["binAddress"] === undefined) {
          this.setState({
            ErrorMessageVal: "Please Enter Bin Address",
            apiCall: false,
            ShowEditLoader: false,
          });
          this.BinErrortoggle();
          return false;
        } else if (neworderData["newPutawayQty"] === undefined) {
          this.setState({
            ErrorMessageVal: "Please Enter Quantity",
            apiCall: false,
            ShowEditLoader: false,
          });
          this.BinErrortoggle();
          return false;
        }

        total_Quantity =
          parseInt(total_Quantity) + parseInt(this.state.rows[i].qty);

        if (this.state.apiCall !== true) {
          await this.setState({ apiCall: true });
        }
        this.state.splitData.push(neworderData);
      }

      /*if (this.state.defaultquantity < total_Quantity) {
        
        this.setState({
          ErrorMessage: 'Total quantity split exceeds the available quantity',
          Errormodal: true,
        })
  
        return false;
      }*/

      if (this.state.apiCall === false) {
        await this.setState({
          apiCall: false,
          ShowEditLoader: false,
          modal: false,
        });
        return false;
      }

      this.setState({ disable_submit_button: true });

      const payload = {
        putawayHistoryId: this.state.putawayHistoryId,
        newPutaway: this.state.splitData,
        location: this.state.selectedLocation,
      };

      API.post("/picking/splitPutaway/v1/", { param: payload })

        .then((response) => {
          console.log(response);

          if (response.data.success_response.length > 0) {
            this.setState({
              schemas: response.data,
              modal: false,
              Successmodal: true,
              ErrorMessage: "Successfully Updated",
              rows: [],
              splitData: [],
              ShowEditLoader: false,
              disable_submit_button: false,
            });

            this.fetchGRNData();
          } else if (response.data.failure_response.length > 0) {
            this.handleRemoveRow2();
            this.setState({
              ErrorMessage: response.data.failure_response[0].reason,
              Errormodal: true,
              /*rows: [],*/
              splitData: [],
              ShowEditLoader: false,
              disable_submit_button: false,
            });
          }

          console.log(this.state.rows);
        })
        .catch(function (error) {});
    }

    /*console.log(this.state.splitData);*/
  }

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal } = this.state;
    const { Errormodal } = this.state;
    const { BinErrormodal } = this.state;
    const { Successmodal } = this.state;
    const { Confirmmodal } = this.state;

    const { modalbeforeConfirm } = this.state;
    const { EditModal } = this.state;
    const { ErrorMessagemodal } = this.state;
    const { newArrayData, selectedUser } = this.state;

    const uniqueZoneData = {};
    newArrayData.map((item) => {
      if (!uniqueZoneData[item.userId]) {
        uniqueZoneData[item.userId] = {
          zoneId: item.userId,
          zoneName: item.userName,
          date: moment(item.date, "MM-DD-YYYY").valueOf(),
          time: moment(item.time, "HH:mm").valueOf(),
          error: item.error,
          items: [],
        };
      }
      uniqueZoneData[item.userId].items.push(item);
    });

    console.log(uniqueZoneData);

    const GRNData = {
      columns: [

        {
          label: "BIN Id",

          field: "binId",
          minimal: "lg",
        },
         {
          label: "Zone Name",

          field: "zone_name",
          minimal: "lg",
        },

        {
          label: "Product Code",

          field: "lbskuid",
          minimal: "lg",
        },

       

        {
          label: "Batch",

          field: "batch",
          minimal: "lg",
        },

        {
          label: "MRP",

          field: "mrp",
          minimal: "lg",
        },


        {
          label: "Outer Qty",

          field: "testerQuantity",
          minimal: "lg",
        },

        {
          label: "Inner Qty",

          field: "receivedIcldQuantity",
          minimal: "lg",
        },


        {
          label: "Each Qty",

          field: "looseQuantity",
          minimal: "lg",
        },

        /*{

          label:'Loose Quantity',

          field:'looseQuantity',
          minimal: 'lg'

        },*/

        {
          label: "Doc Date",

          field: "stnDate",
          minimal: "lg",
        },

        {
          label: "Doc Number",

          field: "stnNumber",
          minimal: "lg",
        },

        {
          label: "PKD",

          field: "pkd",
          minimal: "lg",
        },

        {
          label: "UPC",

          field: "upc",
          minimal: "lg",
        },


        /*{

          label:'GRN Date Time',

          field:'grnDateTime',

        },*/

        /*{

          label:'Base Pack Desc',

          field:'basePackDesc',

        },*/

    
        {
          label: "Crate/Loc",

          field: "crateId",
          minimal: "lg",
        },

       
      ],

      rows: this.state.tableRowsGRN,
    };

    console.log(this.state.rows);

    return (
      <Col xl={12}>
        <Card>
          <CardBody style={{height: 70}}>
           
            <form className="form form--inline" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-4"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-5"
                  style={{ display: "none", paddingTop: 6, paddingBottom: 6 }}
                >
                  Select Putaway No.
                </span>

                <div
                  className="form__form-group-field col-xl-4"
                  style={{ display: "contents" }}
                >
                  <select
                    className="form-control"
                    value={this.state.value}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChange}
                  >
                    <option value="0">Select GRN No.</option>
                    {this.state.schemas &&
                      this.state.schemas.length > 0 &&
                      this.state.schemas.map((schema) => {
                        return (
                          <option value={schema.grnLineNumber}>
                            {" "}
                            {schema.grnLineNumber}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div className="form__form-group col-xl-3">
                <div className="form__form-group-field">
                  <ButtonToolbar className="form__button-toolbar">
                    <Button
                      color="primary"
                      className="btn-sm"
                      type="submit"
                      style={{
                        fontWeight: "normal",
                        textTransform: "capitalize",
                        borderRadius: 5,
                        backgroundColor: "#70bbfd",
                        color: "#fff",
                        padding: "5px 25px",
                        fontSize: "14px",
                      }}
                      onClick={this.SubmitClick}
                    >
                      Submit
                    </Button>
                  </ButtonToolbar>
                </div>
              </div>
            </form>
          </CardBody>

          {this.state.showFetchGRNData && (
            <CardBody style={{ marginTop: 8 }}>
              <div className="table_header">
                <span>
                  {" "}
                  <span style={{ fontWeight: "bold" }}> GRN Number: </span>{" "}
                  <span> {this.state.grnValues} </span>
                </span>

                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    color="primary"
                    disabled={this.state.disabledProperties}
                    className="btn-sm"
                    onClick={this.beforeConfirm}
                    type="submit"
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                  >
                    {this.state.loadingbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Confirm
                  </Button>
                </ButtonToolbar>
              </div>

              <div className="table_val">
                <MDBTable scrollX={true} striped bordered>
                  <MDBTableHead columns={GRNData.columns} />
                  <MDBTableHead>
                    {this.state.loadingGRNValue && (
                      <div
                        style={{
                          width: "2300%",
                          textAlign: "center",
                          paddingTop: 22,
                        }}
                      >
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px", fontSize: 18 }}
                        />
                      </div>
                    )}
                  </MDBTableHead>
                  <MDBTableBody rows={GRNData.rows} />
                </MDBTable>
              </div>
            </CardBody>
          )}
        </Card>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Split Quantity
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div style={{ width: "100%" }}>
              <div style={{ width: "31%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> LB SKU ID: </span>{" "}
                  <span> {this.state.lbskuid_val} </span>{" "}
                </span>
              </div>

              <div style={{ width: "22%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> Qty: </span>{" "}
                  <span> {this.state.defaultquantity} </span>{" "}
                </span>
              </div>

              <div style={{ width: "22%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> PKD: </span>{" "}
                  <span> {this.state.pkd_val} </span>{" "}
                </span>
              </div>

              <div style={{ width: "25%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> MRP: </span>{" "}
                  <span> {this.state.mrp_val} </span>{" "}
                </span>
              </div>
            </div>

            <table className="table table-bordered table-hover" id="tab_logic">
              <thead style={{ textAlign: "left" }}>
                <tr>
                  <th>BIN</th>
                  <th>QTY</th>
                </tr>
              </thead>
              <tbody>
                <tr onClick={this.closeContainer}>
                  <td style={{ textAlign: "left" }}>
                    <div className="search-container">
                      <div className="react-search-field test-class">
                        <input
                          className="react-search-field-input"
                          placeholder="Search for Bearing No."
                          type="text"
                          style={{ padding: 4, borderRadius: 2 }}
                          defaultValue={this.state.typeaheadText}
                          value={this.state.typeaheadText}
                          onChange={this.showTypeahead}
                        />
                      </div>

                      {this.state.showTypeahead && (
                        <div
                          className="suggestions-container"
                          ref={(el) => (this.typeahead = el)}
                        >
                          {this.state.zwz_search_pannel && (
                            <div
                              className="suggestions"
                              onClick={this.closeContainer}
                            >
                              {this.state.data.length > 0 &&
                                this.state.data.map((item, index) => (
                                  <p
                                    key={index}
                                    onClick={() =>
                                      this.setBinId(item.binAddress)
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.binAddress}{" "}
                                  </p>
                                ))}

                              {this.state.data.length === 0 && (
                                <p
                                  onClick={this.closeContainer}
                                  className="typeahead-text"
                                >
                                  {" "}
                                  No Result Found{" "}
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={{ textAlign: "left" }}>
                    <input
                      type="text"
                      value={this.state.quantity}
                      onChange={this.showTypeaheadChange}
                      style={{ padding: 4, borderRadius: 2 }}
                    />
                    <i
                      onClick={this.handleAddRow}
                      class="fa fa-plus-circle"
                      style={{
                        marginLeft: 15,
                        fontSize: 17,
                        cursor: "pointer",
                      }}
                    ></i>
                    <i
                      onClick={this.handleRemoveRow}
                      class="fa fa-minus-circle"
                      aria-hidden="true"
                      style={{
                        marginLeft: 15,
                        fontSize: 17,
                        cursor: "pointer",
                      }}
                    ></i>
                  </td>
                </tr>

                {this.state.rows.map((row, index) => (
                  <tr onClick={() => this.closeContainerIndex(index)}>
                    <td style={{ textAlign: "left" }}>
                      <div className="search-container">
                        <div className="react-search-field test-class">
                          <input
                            className="react-search-field-input"
                            placeholder="Search for Bin Address"
                            type="text"
                            style={{ padding: 4, borderRadius: 2 }}
                            value={row.binId}
                            onChange={(e) =>
                              this.onBinChange1(index, e.target.value)
                            }
                          />
                        </div>

                        {this.state.showContainer[index] && (
                          <div
                            className="suggestions-container"
                            ref={(el) => (this.typeahead = el)}
                          >
                            <div
                              className="suggestions"
                              onClick={this.closeContainer}
                            >
                              {this.state.data.length > 0 &&
                                this.state.data.map((item, i) => (
                                  <p
                                    key={i}
                                    onClick={() =>
                                      this.setBinIdLoop(index, item.binAddress)
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.binAddress}{" "}
                                  </p>
                                ))}

                              {this.state.data.length === 0 && (
                                <p
                                  onClick={this.closeContainer}
                                  className="typeahead-text"
                                >
                                  {" "}
                                  No Result Found{" "}
                                </p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <input
                        type="text"
                        onChange={(e) =>
                          this.onQuantityChange1(index, e.target.value)
                        }
                        style={{ padding: 4, borderRadius: 2 }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.togglePressCancel}
              >
                Cancel
              </button>

              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                disabled={this.state.disable_submit_button}
                onClick={this.processData}
              >
                {this.state.ShowEditLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Submit
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={modalbeforeConfirm}
          toggle={this.beforeConfirm}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>User Id</th>
                  <th>User Name</th>
                  {/*<th>Select Date</th>
                  <th>Select Time</th>*/}
                </tr>
              </thead>

              <tbody>
                {Object.keys(uniqueZoneData).length > 0 &&
                  _.map(uniqueZoneData, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                     {/* <td>
                        <DatePicker
                          dateFormat="MM/dd/yyyy"
                          selected={item.date}
                          minDate={new Date()}
                          onChange={(date) =>
                            this.handleChangeDate(item.zoneName, date)
                          }
                        />
                      </td>

                      <td>
                        <TimePicker
                          format="HH:mm"
                          onChange={(time) =>
                            this.handleChangeTime(item.zoneName, time)
                          }
                        />
                        <br />
                        {item.error && (
                          <span style={{ color: "red" }}>{item.error}</span>
                        )}
                      </td>*/}
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <button
                style={{
                  backgroundColor: "#ddd",
                  color: "#fff",
                  textTransform: "capitalize",
                }}
                className="modal_cancel"
                onClick={this.CancelBeforeModal}
              >
                Cancel
              </button>
              <Button
                disabled={this.state.disabledBtnConfirm}
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  textTransform: "capitalize",
                }}
                className="modal_ok"
                onClick={this.ConfirmPutAway}
              >
                {this.state.showConfirmLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal isOpen={BinErrormodal} toggle={this.BinErrortoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.BinErrortoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.ErrorMessageVal} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.BinErrortoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Errormodal} toggle={this.Errortoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Errortoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.ErrorMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Errortoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.CancelSuccessToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Confirmmodal} toggle={this.Confirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Confirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.CancelConfirmToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
